<template>
  <div class="aboutcontainer">
    <div class="aboutusbody ">
      <h1 class="wow fadeInUp">{{titlename}}</h1>
      <div class="bodybottom wow slideInLeft">

        <div v-for="(item,inedx) in listdata">
<!--          -->
          <div class="texth1"v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn" >{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}</div>
          <hr v-show="inedx>0" align="center" width="2px" style="border:1px solid #2FA8DB;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "AboutUs",
    props: ['titlename', 'listdata'],
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .aboutcontainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 3%;
      .aboutusbody {

        width: 100%;
        max-width: 1630px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        h1 {
          font-size: 3.2em;
          color: black;
        }

        .bodybottom {
          margin-top: 9%;
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-around;

          div {
            padding: 10px 0;
            width: 100%;
            color: #40B3EC;
            position: relative;
            .texth1{
                /deep/ h1{
                  font-size: 3em !important;
                }
              }

            hr {
              top: 0.5vw;
              position: absolute;
              height: 6.5vw;
            }

            /*h2{*/
            /*  font-size: 5em;*/
            /*  display : inline;*/
            /*}*/
            /*span{*/
            /*  font-weight: bold;*/
            /*  font-size: 25px;*/
            /*}*/
            /*p{*/
            /*  font-size: 25px;*/
            /*}*/
          }
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .aboutcontainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .aboutusbody {

        width: 100%;
        max-width: 1630px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        h1 {
          font-size: 3.2em;
          color: black;
        }

        .bodybottom {
          margin-top: 9%;
          display: flex;
          align-items: flex-start;
          width: 100%;
          justify-content: space-around;

          /*hr {*/
          /*  margin: 0 2vw;*/
          /*  height: 18vw;*/
          /*}*/

          div {
            padding: 10px 0;
            width: 100%;
            color: #40B3EC;
            position: relative;
            .texth1{
              /deep/ h1{
                font-size: 3em !important;
              }
            }
            hr {
              top: 2.5vw;
              position: absolute;
              margin: 0 0.5vw;
              height: 14vw;
            }
            /*h2 {*/
            /*  font-size: 5em;*/
            /*  display: inline;*/
            /*}*/

            /*span {*/
            /*  font-weight: bold;*/
            /*  font-size: 1em;*/
            /*}*/

            /*p {*/
            /*  font-size: 1em;*/
            /*}*/
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/homecomponents/aboutUs_home.vue